import { Box } from "@chakra-ui/react";
import { CloseButton } from "./shared/CloseButton";
import React, { FC, useState } from "react";
import SafeImage from "./SafeImage";
import RulePencilIcon from "assets/RulePencilIcon.svg?url";

interface WebsiteListItemProps {
	isActiveTab: boolean;
	forceCloseTab: (arg0: string, arg1: boolean) => void;
	item: {
		tab_id: string;
		favIcon: string;
		favicon: string;
	};
	classIsActive: string;
	handleOpenRuleModal: (arg0: { url: string; id: string; title: string }) => void;
	comComponent: {
		url: string;
		id: string;
		title: string;
	};
	itemKey: string;
	isMonitorMode: boolean;
	canCloseTab: boolean;
	canCreateRule: boolean;
}

export const WebsiteListItem: FC<WebsiteListItemProps> = ({
	isActiveTab,
	forceCloseTab,
	item,
	classIsActive,
	handleOpenRuleModal,
	comComponent,
	itemKey,
	isMonitorMode,
	canCloseTab,
	canCreateRule = true,
}) => {
	const [isClosed, changeClosed] = useState(false);

	const handleClose = () => {
		forceCloseTab(item.tab_id, isActiveTab);
		changeClosed(true);
	};

	const disableClose = () => {
		return !item.tab_id || isClosed || !classIsActive;
	};

	const openRuleModal = () => {
		handleOpenRuleModal(comComponent);
	};

	return (
		<Box
			className={!isClosed ? "WebsiteOrSignatureListModal_infoElement" : "WebsiteOrSignatureListModal_infoElement--closed"}
			key={itemKey}
		>
			<SafeImage styleClassName="WebsiteOrSignatureListModal_favicon" src={item.favIcon || item.favicon} />
			<Box flex={30} className={"WebsiteOrSignatureListModal_infoTitle"} title={comComponent.url ? comComponent.url : comComponent.id}>
				{comComponent.title}
			</Box>
			{!isMonitorMode && canCreateRule && (
				<button onClick={openRuleModal} className={"WebsiteOrSignatureListModal_ruleButton"}>
					<Box>
						<img className={"WebsiteOrSignatureListModal_ruleIcon"} src={RulePencilIcon} alt="" />
					</Box>
					<Box className={"WebsiteOrSignatureListModal_ruleText"}>Rule</Box>
				</button>
			)}
			{canCloseTab && (
				<Box flex={1}>
					<CloseButton
						tooltipText="Close Tab"
						tooltipId={item.tab_id + "_closeTabTooltip"}
						disabled={disableClose()}
						onClick={handleClose}
					/>
				</Box>
			)}
		</Box>
	);
};
